export let Code = {
type: `@Component({
    selector: 'p-card',
    template:
        <p-card title="Simple Card" [style]="{width: '360px'}">
	    <div>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Inventore sed consequuntur error repudiandae numquam deserunt
	        quisquam repellat libero asperiores earum nam nobis, culpa ratione quam perferendis esse, cupiditate neque quas!</div>
	</p-card>
	<br>
	<br>

	<p-card title="Advanced Card" subtitle="Subtitle" [style]="{width: '360px'}" styleClass="ui-card-shadow">
	    <p-header>
	        <img src="Card" src="assets/showcase/images/usercard.png">
	    </p-header>
	    <div>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Inventore sed consequuntur error repudiandae numquam deserunt
	        quisquam repellat libero asperiores earum nam nobis, culpa ratione quam perferendis esse, cupiditate neque quas!</div>
	    <p-footer>
	        <button pButton type="button" label="Save" icon="ion-checkmark-round"></button>
	        <button pButton type="button" label="Cancel" icon="ion-close-round" class="ui-button-secondary"></button>
	    </p-footer>
	</p-card>
})
export class Card {

}
`
};


// WEBPACK FOOTER //
// ./src/app/code/card.ts